import { useMemo } from 'react';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useServicesPerYearDonutChart = () => {
    const { chartData, subtitles } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            subtitles.map((item, index) => {
                const data =
                    chartData.counterServices?.reduce(
                        (acc, curr) =>
                            acc +
                            (index === 0
                                ? Number(curr.total_acommodations)
                                : Number(curr.total_permanences)),
                        0
                    ) || 0;

                return data;
            }),
        [chartData, subtitles]
    );

    return {
        series,
        subtitles
    };
};

export default useServicesPerYearDonutChart;
